// Document Type Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { documentTypeConfig } from './documentTypeConfig';
import { createDocumentTypeValidation } from './documentTypeValidation';
// DocumentTypeService no longer needed - using SWR hooks directly

/**
 * Initialize the document type module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  documentTypeConfig,
  createDocumentTypeValidation
);

/**
 * Create the DocumentTypePage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const DocumentTypePage = createModulePage(
  initializedConfig,
  {
    displayName: 'DocumentTypePage',
    description: 'Document Type Management System - Manage document categories and classifications'
  }
);

export default DocumentTypePage;
